import React, { useEffect, useState } from "react";
import { HiChevronRight, HiOutlineSearch } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ImSpinner2 } from "react-icons/im";
import { formatCreatedAt, formatTime } from "../../utils/commonUtils";
import { IoEyeOutline } from "react-icons/io5";
import { fetchFutureDeliveries } from "../../redux/slices/futureDeliverySlice";
import CancelOrder from "../../components/modals/cancel/CancelOrder";
import { fetchUsers } from "../../redux/slices/userSlice";
import ModalFutureDelievry from "../../components/modals/order/ModalFutureDelievry";

const OrderFutureDeliveries = () => {
  const [search, setSearch] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFutureDeliveries());
    dispatch(fetchUsers());
  }, [dispatch]);

  const futureDeliveries = useSelector(
    (state) => state.futureDelivery.futureDeliveries,
  );

  const usersList = useSelector((state) => state.user?.users);

  const states = JSON.parse(localStorage.getItem("state"));
  const provinces = JSON.parse(localStorage.getItem("province"));

  const status = useSelector((state) => state.futureDelivery?.status);
  const error = useSelector((state) => state.futureDelivery?.error);

  // Filter categories based on search term and delivery_date
  const filteredFutureDeliveries = futureDeliveries?.filter((order) => {
    const matchesSearch =
      search.toLowerCase() === "" ||
      order?.customer?.name.toLowerCase().includes(search) ||
      order.order_id.toString().toLowerCase().includes(search.toLowerCase());
    const matchesDate =
      !filterDate ||
      new Date(order.delivery_date).toISOString().split("T")[0] === filterDate;

    return matchesSearch && matchesDate;
  });

  // Calculate the index of the first and last item to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentFutureDeliveries = filteredFutureDeliveries?.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredFutureDeliveries?.length / itemsPerPage);

  // Function to handle pagination
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const getStateNameFromId = (stateId) => {
    const state = states?.find((state) => state.id === parseInt(stateId, 10));
    return state ? state.name : "No state";
  };

  const getCityNameFromId = (provinceId) => {
    const province = provinces?.find(
      (province) => province.id === parseInt(provinceId, 10),
    );
    return province ? province.name : "No city";
  };

  const getUserDetailFromId = (userId) => {
    const user = usersList?.find((user) => user.id === parseInt(userId, 10));
    if (!user) {
      return { city: "N/A", state: "N/A" };
    }

    // Get the actual state and city names from their IDs
    const stateName = getStateNameFromId(user.state); // Assuming user.state is stateId
    const cityName = getCityNameFromId(user.province); // Assuming user.province is provinceId

    return {
      city: cityName,
      state: stateName,
    };
  };

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Shopping Future Deliveries
          </h1>

          <div className="flex mb-4 justify-center items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#1F7BF4]  font-medium">Shopping</p>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#667085] font-medium">
              Future Deliveries
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-between mb-4">
        <button className="relative w-72">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <HiOutlineSearch className=" text-gray-500 text-2xl" />
          </div>
          <input
            type="text"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
            placeholder="Search orders..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </button>
        <div className="">
          <input
            type="date"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full pl-2 p-2"
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left whitespace-nowrap text-gray-500">
            <thead className="text-sm text-gray-700 bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-center">No.</th>
                <th className="px-4 py-4 text-left">Customer Name</th>
                <th className="px-2 py-3 text-center">Order Id</th>
                <th className="px-2 py-3 text-center ">Date</th>
                <th className="px-2 py-3 text-center ">Time</th>
                <th className="px-2 py-3 text-center ">Cancel Order</th>

                <th className="px-4 py-3 text-center">Shopping location</th>
                <th className="px-4 py-3 text-center">Payment method </th>
                <th className="px-4 py-3 text-center">Delivery method</th>
                <th className="px-2 py-3 text-center">Delivery Time</th>
                <th className="px-2 py-3 text-center">Delivery Date</th>
                <th className="px-2 py-3 text-center">Created</th>
                <th className="px-2 py-3 text-center">Updated</th>
                <th className="px-2 py-3 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="w-fit">
              {status === "failed" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : currentFutureDeliveries?.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center text-gray-500 py-4">
                    No Data
                  </td>
                </tr>
              ) : (
                currentFutureDeliveries?.map((order, index) => (
                  <tr
                    key={order.id}
                    className="bg-white border-b whitespace-nowrap"
                  >
                    <td className="px-4 py-4">
                      <div className="flex justify-center items-center">
                        <p className=" text-base text-center font-semibold ">
                          {indexOfFirstItem + index + 1}
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-left">
                      <Link to={`/dashboard/user/user-detail/${order.user_id}`}>
                        <div className=" flex flex-col gap-2">
                          <p className=" text-base  font-bold">
                            {order.customer?.name}
                          </p>
                          <p className="font-semibold">
                            {order.customer?.phone}
                          </p>
                          <p className="font-semibold">
                            {getUserDetailFromId(order.user_id).city},{" "}
                            {getUserDetailFromId(order.user_id).state}
                          </p>
                          <p>{order.customer?.email}</p>
                        </div>
                      </Link>
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap">
                      <Link
                        to={`/dashboard/orders/future-deliveries/${order.order_id}`}
                      >
                        <p className="px-4 py-1 text-base text-center font-semibold text-blue-600">
                          {order.order_id}
                        </p>
                      </Link>
                    </td>
                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {formatCreatedAt(order.delivery_date)}
                    </td>
                    <td className="px-2 py-2 text-center whitespace-nowrap">
                      {formatTime(order.delivery_date)}
                    </td>
                    <td className="px-4 py-2">
                      <div className=" flex justify-center items-center">
                        <CancelOrder
                          orderId={order.order_id}
                          name={order.customer?.name}
                          user_id={order.user_id}
                        />
                      </div>
                    </td>

                    <td className="px-4 py-2 text-center">
                      {order?.details ? (
                        <div className=" flex flex-col gap-2">
                          <p>{order?.details?.name}</p>
                          <p>{order?.details?.state?.name}</p>
                        </div>
                      ) : (
                        "No Data"
                      )}
                    </td>
                    <td className="px-4 py-2 text-center">
                      {order.method ? order.method : "-"}
                    </td>
                    <td className="px-4 py-2 text-center">{order.dropoff}</td>

                    <td className="px-4 py-2 text-center">
                      <div>
                        <p className="font-semibold">
                          {formatTime(order.delivery_date)}
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-center">
                      <div>
                        <p className="font-semibold">
                          {formatCreatedAt(order.delivery_date)}
                        </p>
                      </div>
                    </td>

                    <td className="px-4 py-2 text-center">
                      <p>{formatCreatedAt(order.created_at)}</p>
                    </td>

                    <td className="px-4 py-2 text-center">
                      <p>{formatCreatedAt(order.updated_at)}</p>
                    </td>
                    <td className="px-2 py-4">
                      <div className="flex gap-4 items-center justify-center">
                        <div>
                          <Link
                            to={`/dashboard/orders/future-deliveries/${order.order_id}`}
                          >
                            <IoEyeOutline className="w-4 h-4 text-[#667085]" />
                          </Link>
                        </div>
                        <div>
                          <ModalFutureDelievry
                            orderId={order.order_id}
                            name={order.customer?.name}
                            user_id={order.user_id}
                            delivery_date={order.delivery_date}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between px-[24px] py-[15px] items-center">
          <p className="text-[14px] py-4 font-medium text-[#667085] tracking-[0.07px]">
            Showing {indexOfFirstItem + 1} - {indexOfLastItem} from{" "}
            {filteredFutureDeliveries?.length}
          </p>

          <div className="flex gap-[8px]">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Previous
            </button>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderFutureDeliveries;
